import script from "./ChatEditResourceView.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatEditResourceView.vue?vue&type=script&setup=true&lang=js"

import "./ChatEditResourceView.vue?vue&type=style&index=0&id=78cdb276&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78cdb276"]])

export default __exports__